!function(){class e extends HTMLElement{connectedCallback(){this.closeButtons=this.querySelectorAll(".product-alert-popup__close-x, .product-alert-popup__close-button"),this.overlay=this.querySelector(".product-alert-popup__overlay"),this.setupEventListeners(),this.show()}setupEventListeners(){this.closeButtons.forEach(e=>{e.addEventListener("click",()=>this.close())}),this.overlay?.addEventListener("click",()=>this.close());let e=e=>{"Escape"===e.key&&this.isOpen&&this.close()};document.addEventListener("keydown",e),this.addEventListener("disconnect",()=>{document.removeEventListener("keydown",e)})}getCustomCursor(){return this.parentElement?.querySelector("custom-cursor")}hideCustomCursor(){let e=this.getCustomCursor();e?.setAttribute("hidden","")}showCustomCursor(){let e=this.getCustomCursor();e?.removeAttribute("hidden")}show(){requestAnimationFrame(()=>{requestAnimationFrame(()=>{this.classList.add("is-visible"),this.hideCustomCursor(),this.isOpen=!0})})}close(){this.classList.remove("is-visible"),this.isOpen=!1,this.showCustomCursor(),setTimeout(()=>{this.classList.add("is-hidden")},300)}constructor(...e){super(...e),this.isOpen=!1}}customElements.get("product-alert-popup")||customElements.define("product-alert-popup",e),({observer:null,initialObserver:null,cachedSizeChart:null,handleMutation(e){this.cachedSizeChart&&e.forEach(()=>{let e=document.querySelector(".variant-picker__option-info"),t=e?.querySelector(".best-fit-size-chart");if(e&&(!t||!t.innerHTML.trim()))try{t&&t.remove();let s=this.cachedSizeChart.cloneNode(!0);e.appendChild(s)}catch(e){console.error("Error restoring size chart:",e)}})},watchForInitialSizeChart(){let e=document.body;this.initialObserver=new MutationObserver(()=>{let e=document.querySelector(".best-fit-size-chart");e?.innerHTML.trim()&&!this.cachedSizeChart&&(this.cachedSizeChart=e.cloneNode(!0),this.initialObserver?.disconnect(),this.startMainObserver())}),this.initialObserver.observe(e,{childList:!0,subtree:!0,characterData:!0,attributes:!0})},startMainObserver(){let e=document.querySelector(".product-info");e&&(this.observer=new MutationObserver(this.handleMutation.bind(this)),this.observer.observe(e,{childList:!0,subtree:!0,characterData:!0,attributes:!0}))},init(){this.watchForInitialSizeChart()},destroy(){this.observer?.disconnect(),this.initialObserver?.disconnect(),this.observer=null,this.initialObserver=null,this.cachedSizeChart=null}}).init()}();

/* bktsqd: move free-shipping widget (Essential Free Shipping Bar) from the cart
   sidebar to full width under the cart items, per design. Test theme only. */
(function () {
  function moveShipBar() {
    var fresh = document.querySelector('.cart-order__recap .free_shipping_card');
    var target = document.querySelector('.cart-order__summary');
    if (!fresh || !target) return;
    var old = target.querySelector('.free_shipping_card');
    if (old) old.remove();
    fresh.classList.add('bktsqd-wide-shipbar');
    target.appendChild(fresh);
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 50);
  }
  if (document.readyState !== 'loading') { moveShipBar(); }
  else { document.addEventListener('DOMContentLoaded', moveShipBar); }
  new MutationObserver(moveShipBar).observe(document.documentElement, { childList: true, subtree: true });
})();

/* bktsqd: quantity steppers — grey out the minus button when the quantity is already at its
   minimum, so a tap that can't do anything doesn't look broken. Covers cart drawer, cart page and
   product page; re-syncs whenever the cart re-renders. */
(function () {
  function sync(root) {
    (root || document).querySelectorAll('quantity-selector').forEach(function (qs) {
      var input = qs.querySelector('input');
      var minus = qs.querySelector('button');
      if (!input || !minus) return;
      var min = parseFloat(input.min) || 1;
      var val = parseFloat(input.value);
      var atMin = !isNaN(val) && val <= min;
      minus.disabled = atMin;
      minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
    });
  }
  function syncSoon() { setTimeout(sync, 0); }
  if (document.readyState !== 'loading') { sync(); } else { document.addEventListener('DOMContentLoaded', function () { sync(); }); }
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('quantity-selector')) syncSoon(); });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('quantity-selector')) syncSoon(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-selector')) syncSoon(); });
  ['cart:refresh', 'cart:change', 'cart:error'].forEach(function (ev) { document.addEventListener(ev, syncSoon); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { syncSoon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 2026-10-13: on phones, pages with the TYPE quick filter (sale + NFL collection) collapse TYPE and SIZE into one row
   of two buttons ("TYPE · ALL", "SIZE · ANY"). Tapping one opens its chip row below; tapping again (or the other)
   closes it. The chips are the same links as before. Without JS, or on desktop, the rows show as usual. */
(function () {
  function init() {
    var type = document.querySelector('.shopify-section--type-quick-filter');
    if (!type || !type.querySelector('.tqf') || document.querySelector('.qf-bar')) return;
    var size = document.querySelector('.shopify-section--size-quick-filter');
    if (size && !size.querySelector('.sqf')) size = null;
    var items = [[type, 'TYPE', '.tqf__chip--active', 'ALL']];
    if (size) items.push([size, 'SIZE', '.sqf__chip--active', 'ANY']);
    var bar = document.createElement('div');
    bar.className = 'qf-bar';
    items.forEach(function (it) {
      var sec = it[0], active = sec.querySelector(it[2]);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qf-bar__btn' + (active ? ' is-set' : '');
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-controls', sec.id);
      b.innerHTML = '<span class="qf-bar__k">' + it[1] + '</span><span class="qf-bar__v"></span><span class="qf-bar__chev" aria-hidden="true"></span>';
      b.querySelector('.qf-bar__v').textContent = active ? active.textContent.trim() : it[3];
      b.addEventListener('click', function () {
        var open = sec.classList.contains('qf-open');
        items.forEach(function (o) { o[0].classList.remove('qf-open'); });
        bar.querySelectorAll('.qf-bar__btn').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        if (!open) { sec.classList.add('qf-open'); b.setAttribute('aria-expanded', 'true'); }
      });
      bar.appendChild(b);
    });
    type.parentNode.insertBefore(bar, type);
    document.documentElement.classList.add('qf-collapsible');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 2026-10-16: product card photo gallery (snippets/product-card.liquid `gallery`): dots + arrows follow the scroll position */
(function () {
  function sync(track) {
    var gal = track.parentNode, w = track.clientWidth || 1, n = track.children.length;
    var i = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
    [].forEach.call(gal.querySelectorAll('.card-gal__dots span'), function (d, k) { d.classList.toggle('is-on', k === i); });
    var prev = gal.querySelector('[data-card-gal-step="-1"]'), next = gal.querySelector('[data-card-gal-step="1"]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === n - 1;
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('card-gal__track')) sync(t);
  }, { capture: true, passive: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-card-gal-step]');
    if (!b) return;
    e.preventDefault();
    var track = b.parentNode.querySelector('.card-gal__track');
    if (track) track.scrollBy({ left: track.clientWidth * Number(b.getAttribute('data-card-gal-step')), behavior: 'smooth' });
  });
})();
